import { styled } from 'styled-system/jsx'

const Wrap = styled('div', {
  base: {
    display: 'inline-flex',
    flexDirection: 'column',
    gap: '4px',
    position: 'relative',
  },
})

const Trigger = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: '1.5px dashed',
    borderColor: '#D8D2EC',
    borderRadius: 'pill',
    paddingX: '12px',
    paddingY: '5px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      color: 'quickpass.primary',
    },
  },
  variants: {
    size: {
      sm: { fontSize: '11px', paddingX: '10px', paddingY: '3px' },
      md: { fontSize: '12px', paddingX: '12px', paddingY: '5px' },
    },
    hasValue: {
      true: {
        borderStyle: 'solid',
        backgroundColor: 'quickpass.primary',
        borderColor: 'quickpass.primary',
        color: '#FFFFFF',
        _hover: {
          backgroundColor: 'quickpass.primary',
          color: '#FFFFFF',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

const Glyph = styled('span', {
  base: {
    fontSize: '13px',
    lineHeight: '1',
  },
})

const Backdrop = styled('div', {
  base: {
    position: 'fixed',
    inset: '0',
    zIndex: '90',
  },
})

const Dropdown = styled('div', {
  base: {
    position: 'absolute',
    top: 'calc(100% + 6px)',
    left: '0',
    minWidth: '220px',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'md',
    boxShadow: '0 24px 48px -16px rgba(26, 19, 48, 0.32)',
    paddingY: '6px',
    zIndex: '95',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const SuggestionRow = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.ink',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    paddingX: '14px',
    paddingY: '8px',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: 'quickpass.surfaceCool',
    },
  },
  variants: {
    isCurrent: {
      true: {
        color: 'quickpass.primary',
      },
    },
  },
})

const RowGlyph = styled('span', {
  base: {
    fontSize: '13px',
    lineHeight: '1',
  },
})

const InputRow = styled('form', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingX: '12px',
    paddingY: '8px',
    borderTop: '1px solid',
    borderColor: '#F0EDFA',
  },
})

const Input = styled('input', {
  base: {
    flex: '1',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    backgroundColor: 'quickpass.surfaceCool',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'sm',
    paddingX: '10px',
    paddingY: '5px',
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
      backgroundColor: '#FFFFFF',
    },
  },
})

const InputAdd = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    borderRadius: 'sm',
    paddingX: '10px',
    paddingY: '5px',
    cursor: 'pointer',
    _disabled: {
      opacity: '0.4',
      cursor: 'not-allowed',
    },
  },
})

const ClearRow = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.warmth',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    paddingX: '14px',
    paddingY: '6px',
    textAlign: 'left',
    transition: 'background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: 'quickpass.surfaceCool',
    },
  },
})

export {
  Wrap,
  Trigger,
  Glyph,
  Backdrop,
  Dropdown,
  SuggestionRow,
  RowGlyph,
  InputRow,
  Input,
  InputAdd,
  ClearRow,
}
